import { render } from "./ReportGenPage.vue?vue&type=template&id=71da5243&ts=true"
import script from "./ReportGenPage.vue?vue&type=script&lang=ts"
export * from "./ReportGenPage.vue?vue&type=script&lang=ts"

import "./ReportGenPage.vue?vue&type=style&index=0&id=71da5243&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__